import { Button, Modal } from 'react-bootstrap';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { sendToDocusign } from 'src/store/actions/contract-actions';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import { IContract } from 'src/types/contract';

interface Props {
    data: IContract;
}

const SendContractAction: React.FunctionComponent<Props> = ({ data: { id, student } }: Props) => {
    const dispatch = useDispatch();
    const [opened, setOpened] = useState(false);
    const handleClose = () => {
        setOpened(false);
    };
    /* eslint-disable */
    /* eslint jsx-a11y/anchor-is-valid: 0 */
    /* eslint-enable */
    return (
        <>
            <button title={'Send with DocuSign'} type="button" onClick={() => setOpened(true)} className="btn btn-success">
                <FontAwesomeIcon icon={faEnvelope} />
            </button>
            <Modal show={opened} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to send the contract to sign?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        variant="danger"
                        onClick={() => {
                            handleClose();
                            dispatch(
                                sendToDocusign(
                                    { id: id, statusDocusign: 2, student: student?.id },
                                    {
                                        resolve: () => {
                                            toast.success('Contract was sent to DocuSign');
                                        },
                                        reject: (errorMessage: string) => {
                                            toast.error(errorMessage);
                                        },
                                    },
                                ),
                            );
                        }}
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default SendContractAction;
